// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3s8N-","content":"styles_content__1GFtI","checkbox":"styles_checkbox__19H4F","checkboxLabel":"styles_checkboxLabel__8Euzs"};